var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.57 5.23C19.96 5.07 18.35 4.95 16.73 4.86V4.85L16.51 3.55C16.36 2.63 16.14 1.25 13.8 1.25H11.18C8.85004 1.25 8.63003 2.57 8.47004 3.54L8.26004 4.82C7.33004 4.88 6.40004 4.94 5.47004 5.03L3.43004 5.23C3.01004 5.27 2.71004 5.64 2.75004 6.05C2.79004 6.46 3.15004 6.76 3.57004 6.72L5.61004 6.52C10.85 6 16.13 6.2 21.43 6.73C21.46 6.73 21.48 6.73 21.51 6.73C21.89 6.73 22.22 6.44 22.26 6.05C22.29 5.64 21.99 5.27 21.57 5.23Z",
    fill: "#F04438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3991,
    d: "M19.73 8.14C19.49 7.89 19.16 7.75 18.82 7.75H6.17999C5.83999 7.75 5.49999 7.89 5.26999 8.14C5.03999 8.39 4.90999 8.73 4.92999 9.08L5.54999 19.34C5.65999 20.86 5.79999 22.76 9.28999 22.76H15.71C19.2 22.76 19.34 20.87 19.45 19.34L20.07 9.09C20.09 8.73 19.96 8.39 19.73 8.14Z",
    fill: "#F04438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.08 17C10.08 16.5858 10.4157 16.25 10.83 16.25H14.16C14.5742 16.25 14.91 16.5858 14.91 17C14.91 17.4142 14.5742 17.75 14.16 17.75H10.83C10.4157 17.75 10.08 17.4142 10.08 17Z",
    fill: "#F04438"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 13C9.25 12.5858 9.58579 12.25 10 12.25H15C15.4142 12.25 15.75 12.5858 15.75 13C15.75 13.4142 15.4142 13.75 15 13.75H10C9.58579 13.75 9.25 13.4142 9.25 13Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a7445364f52a4f8227d7726a4869f83b.svg";
export { ForwardRef as ReactComponent };